import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';

export function isRefreshAdFlightEnabled(): boolean {
    return (
        isMiniFeatureEnabled('miniAE-Refresh-202206-20s') ||
        isMiniFeatureEnabled('miniAE-Refresh-202206-30s') ||
        isMiniFeatureEnabled('miniAE-Refresh-202206-40s')
    );
}
